import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[wzTranslate]',
  standalone: false,
})
export class TunnelSanteTranslateDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @Input()
  set wzTranslate(data: { step: number; length: number }) {
    if (data.length === 0) {
      throw Error('TunnelSanteTranslateDirective : length is equal to 0');
    }
    let offsetPerc = 100 / data.length;
    let current = -data.step * offsetPerc;
    this.renderer.setStyle(
      this.el.nativeElement,
      'transform',
      `translateX(${current}%)`,
    );
  }
}
